import { KonvaEventObject } from 'konva/lib/Node';
import { useStore } from 'react-redux';
import { RootState } from '@/app/appStore';
import { SkuImage } from '@/pages/home/ui/sku-image';
import {
  RelativeVector2d,
  attachPointToSku,
  deletePoint,
  isReadOnly,
  selectIsControlsDisabled,
  skusWithPoints,
  updateFramePoint,
} from '@/entities/collection';
import { useAppDispatch, useAppSelector } from '@/shared/hooks';
import { VIDEO_ASPECT_RATIO } from '@/shared/lib';

export function SkuImages() {
  const skuToPoint = useAppSelector((state) => state.collection.skuToPoint);
  const isReadOnlyMode = useAppSelector(isReadOnly);
  const selectedSkuList = useAppSelector(skusWithPoints);
  const isControlsDisabled = useAppSelector(selectIsControlsDisabled);
  const store = useStore<RootState>();
  const dispatch = useAppDispatch();
  const canvasDimensions = useAppSelector((state) => state.canvas.dimensions);

  const setCursor = (
    e: KonvaEventObject<PointerEvent | DragEvent>,
    cursor: string
  ) => {
    const stage = e.target.getStage();
    stage && (stage.container().style.cursor = cursor);
  };

  return (
    <>
      {selectedSkuList.map((variant) =>
        skuToPoint[variant.variantIndex] ? (
          <SkuImage
            deleteEnabled={!isReadOnlyMode && !isControlsDisabled}
            draggable={!isReadOnlyMode && !isControlsDisabled}
            key={variant.variantIndex}
            x={
              skuToPoint[variant.variantIndex]!.relativeX *
              canvasDimensions.canvasWidth
            }
            y={
              skuToPoint[variant.variantIndex]!.relativeY *
              (canvasDimensions.canvasWidth / VIDEO_ASPECT_RATIO)
            }
            imgSrc={variant.image}
            onDelete={() => {
              dispatch(deletePoint({ variantIndex: variant.variantIndex }));
            }}
            onPointerEnter={(e) => {
              if (isReadOnlyMode) return;
              setCursor(e, 'grab');
            }}
            onPointerLeave={(e) => {
              if (isReadOnlyMode) return;
              setCursor(e, 'default');
            }}
            onPointerDown={(e) => {
              if (isReadOnlyMode) return;
              setCursor(e, 'grabbing');
            }}
            onDragEnd={(e) => {
              if (isReadOnlyMode) return;

              const state = store.getState();
              const x = e.target.x() + 24;
              const y = e.target.y() + 24;

              const newCoordinates: RelativeVector2d = {
                x,
                y,
                relativeX: x / state.canvas.dimensions.canvasWidth,
                relativeY:
                  (y * VIDEO_ASPECT_RATIO) /
                  state.canvas.dimensions.canvasWidth,
              };

              if (state.collection.selectedFrameIndex > -1) {
                dispatch(
                  updateFramePoint({
                    variantIndex: variant.variantIndex,
                    point: newCoordinates,
                  })
                );
              }
              dispatch(
                attachPointToSku({
                  variantIndex: variant.variantIndex,
                  point: newCoordinates,
                })
              );

              setCursor(e, 'grab');
            }}
          />
        ) : null
      )}
    </>
  );
}
